<template>
	<div class="modal" :class="cssClass">
		<div class="modal-wrapper">
			<div class="modal-container">
				<button class="button-transparent close" @click="close()">X</button>
				<div class="modal-body">
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['size'],
	data() {
		return {
			active: false,
			isOpen: false
		}
	},
	methods: {
		open() {
			this.active = true

			setTimeout(() => {
				this.isOpen = true
			}, 1)
			
		},
		close() {
			let self = this

			this.isOpen = false

			setTimeout(() => {
				self.active = false
				self.$emit('close')
			}, 500)

		}
	},
	computed: {
		cssClass() {
			return { 
				active: this.active,
				open: this.isOpen,
				'modal-small': this.size === 'small',
				'modal-medium': this.size === 'medium',
				'modal-large': this.size !== 'small' && this.size !== 'medium',
			}
		}
	},
	mounted() {
		this.open()
	}
}
</script>

<style lang="scss">
@import './../scss/variables';
@import './../scss/mixins.scss';

.modal {
	display: none;
	position: fixed;
	z-index: 5;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0);
	transition: background-color .5s ease;
	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
		.modal-container {
			position: relative;
			margin: 0px auto;
			padding: 30px;
			padding-bottom: 0;
			background-color: #fff;
			@include border-radius(3px);
			@include box-shadow(0px 3px 60px 0px rgba(0,0,0,0.3));
			transition: top .5s ease;
			overflow: hidden;
			@media(max-width: $grid-md-max) {
				padding-left: 15px;
				padding-right: 15px;
			}
			button.close {
				position: absolute;
				top: 20px;
				right: 24px;
				font-size: 20px;
			}
			.modal-body {
				margin-top: 15px;
				padding-bottom: 45px;
				max-height: 80vh;
				overflow-y: auto;
				h3 {
					display: inline-block;
					font-size: 28px;
					line-height: 34px;
					color: #0C2D39;
					font-weight: 300;
					margin-top: 0;
				}
			}
		}
	}
}
.modal.active {
	display: table;
	.modal-container {
		top: -2000px;
	}
}
.modal.open {
	background-color: rgba(0, 0, 0, .5);
	.modal-container {
		top: 0;
	}
}
.modal.modal-large .modal-container {
	max-width: 950px;
	@media(max-width: 990px) {
		width: calc(100% - 40px);
	}
}
.modal.modal-medium .modal-container {
	max-width: 750px;
	@media(max-width: 790px) {
		width: calc(100% - 40px);
	}
}
.modal.modal-small .modal-container {
	max-width: 600px;
	@media(max-width: 640px) {
		width: calc(100% - 40px);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue